import Vue from 'vue'
// import { firebaseMutations, firebaseAction } from 'vuexfire'
import u from '@/util'
import { t } from '@/i18n'
import data from '@/data'
// const ref = data.db.ref('/meetings')

const state = {
  cell: '',
  dates: [],
  index: -1,
  date: null,
  content: '',
  attendance: [],
  present: {},
  dirty: false,
  valid: true
}

const getters = {
  attendance: (state, a, b, rootGetters) =>
    (state.date ? rootGetters['assignment/itemsByDate'](state.date) : [])
      .map(_ => ({
        person: _.person,
        role: _.role,
        present: state.present[_.person] !== undefined ? // check if modified from the screen
          state.present[_.person] :
          state.attendance.includes(_.person)
      }))
      .sort((a, b) => a.person > b.person ? 1 : a.person < b.person ? -1 : 0),
  nextDate: state => {
    const { dates, index } = state
    return index > -1 && index < dates.length - 1 && dates[index + 1]
  },
  prevDate: state => {
    const { dates, index } = state
    const i = index === -1 ? dates.length : index
    return i > 0 && dates[i - 1]
  },
  lastDate: state => state.dates[state.dates.length - 1] || '',
  isNew: state => state.index === -1,
  validations: state => ({
    date: [
      v => !!v || t('Date incorrect'),
      v => !v || state.index !== -1 || !state.dates.includes(v) ||
        t('Meeting date already exists', state.date)
    ]
  }),

  // Meeting statistics
  members: (state, g) => g.attendance.filter(_ => _.role !== 'G' && _.role !== 'V'),
  memberCount: (state, g) => g.members.length,
  presentMemberCount: (state, g) => g.members.filter(_ => _.present).length,
  presentCount: (state, g) => g.attendance.filter(_ => _.present).length,
  presentCountG: (state, g) => g.attendance.filter(_ => _.present).filter(_ => _.role === 'G').length,
  presentCountV: (state, g) => g.attendance.filter(_ => _.present).filter(_ => _.role === 'V').length,
  percent: (state, g) => g.memberCount ?
    (g.presentMemberCount / g.memberCount * 100).toFixed() : 0
}

const mutations = { // firebaseMutations
  dates (state, { cell, dates, index }) {
    state.cell = cell
    state.dates = dates
    mutations.index(state, index !== undefined ? index : dates.length - 1)
  },
  index (state, value) {
    // state.dirty = value === -1
    state.index = value
    state.date = state.dates[state.index] ||
      (state.dates.length && u.dateAdd(state.dates[state.dates.length - 1], 7)) || u.today()
  },
  date (state, value) { state.date = value },
  content (state, value) { state.content = value },
  dirty (state, value) { state.dirty = value },
  valid (state, value) { state.valid = value },
  setMeeting (state, { attendance, content }) {
    state.attendance = attendance || []
    state.content = content
    state.present = {}
  },
  togglePresent (state, { person, value }) {
    Vue.set(state.present, person, value)
    state.dirty = true
  }
}

const actions = {
  dates (context, cell) {
    return data.meetings.findDates(cell).then(d => {
      const dates = d || []
      context.commit('dates', { cell, dates })
      context.dispatch('meeting')
      return dates
    })
  },
  meeting (context, index) {
    if (index !== undefined) {
      context.commit('index', index)
    }
    const cell = context.rootGetters.cell
    // console.log(cell, context.state.date)
    return data.meetings.findByCellDate(cell, context.state.date).then(m => {
      const meeting = m || {
        attendance: [],
        content: ''
      }
      context.commit('setMeeting', meeting)
      return meeting
    })
  },
  async create (context) {
    // assumtion: 'meetings' action has been called beforehand to bind assignments
    if (await actions['pass dirty?'](context)) {
      const meeting = { attendance: [], content: '' }
      context.commit('index', -1)
      context.commit('dirty', true)
      context.commit('setMeeting', meeting)
      return meeting
    }
  },
  async save (context, send) {
    const valid = await context.dispatch('valid', { module: 'meeting' }, { root: true })
    if (!valid) return
    const { cell, date, content, dates, index } = context.state
    if (dates[index] !== date) { // Date modified or added
      const newDates = [...dates]
      if (dates[index]) {
        newDates.splice(index, 1)
      }
      if (newDates.includes(date)) {
        context.commit('error', t('Meeting date already exists', date))
        return
      }
      newDates.push(date)
      newDates.sort()
      const newIndex = newDates.indexOf(date)
      context.commit('dates', { cell, dates: newDates, index: newIndex })
    }

    const meeting = {
      attendance: context.getters.attendance.filter(_ => _.present).map(_ => _.person),
      content
    }

    await data.meetings.save(cell, context.state.dates, date, meeting)
    context.commit('dirty', false)

    if (send) {
      // Send emails
      const to = (await data.cells.findOne(context.rootGetters.cell) || {}).reportEmails
      if (!to) {
        context.commit('snackbar', t('Saved'), { root: true })
        return
      }
      const { attendance, presentCount, presentMemberCount, memberCount, percent } = context.getters
      const mailOptions = {
        from: t('Email from'),
        to: to,
        cell,
        subject: t('Meeting email subject', cell, false),
        html: `<p>Data: ${date}</p>` +
            `<p>${t('Persons count')}: ${presentCount}</p>` +
            `<p>${t('Attendance without guests')}: ${presentMemberCount}/${memberCount} = ${percent}%</p><table>` +
           attendance.map(a =>
             `<tr><td>${a.present ? '√&nbsp;' : ''}</td><td>${a.person}</td></tr>`).join('') +
           `</table><p>${t('Content')}: </br>${meeting.content}</p>`
      }
      data.mailer.create(mailOptions)
      context.commit('snackbar', t('Sent'), { root: true })
    } else {
      context.commit('snackbar', t('Saved'), { root: true })
    }
  },
  send (context) {
    context.dispatch('save', true)
  },

  async remove (context) {
    const { cell, date, dates, index } = context.state
    // const limitDate = u.dateAdd(u.today(), -30)
    // if (date < limitDate) {
    //   context.commit('error', t('Cannot remove before date', limitDate), { root: true })
    //   return
    // }
    const params = { params: t('meeting with params', date) }
    if (await context.dispatch('confirmDelete', params, { root: true })) {
      const newDates = [...dates]
      newDates.splice(index, 1)
      const payload = { cell, dates: newDates, index: Math.min(index, newDates.length - 1) }
      context.commit('dates', payload)
      context.dispatch('meeting', payload.index)
      await data.meetings.save(cell, newDates, date, null)
      context.commit('snackbar', t('Removed'), { root: true })
    }
  },

  async prev (context) {
    if (await actions['pass dirty?'](context)) {
      if (context.state.index === -1) {
        return context.dispatch('meeting', context.state.dates.length - 1)
      } else if (context.state.index > 0) {
        return context.dispatch('meeting', context.state.index - 1)
      }
    }
  },
  async next (context) {
    if (await actions['pass dirty?'](context)) {
      if (context.state.index < context.state.dates.length - 1 && context.state.index >= 0) {
        return context.dispatch('meeting', context.state.index + 1)
      }
    }
  },
  // // Returns [{ path, attendace }]
  // personAttendance (context, payload) {
  //   const { cell } = payload
  //   const promise = context.state.dates.length !== 0
  //     ? Promise.resolve(context.state.dates)
  //     : context.dispatch('meeting/dates', payload)
  //   return promise.then(dates =>
  //     Promise.all(dates.map(date => {
  //       const path = ref.child(cell).child(date).child('attendance')
  //       return path.once('value').then(s => ({ path, attendance: s.val() }))
  //     })).then(data => data.filter(_ => _.attendance && _.attendance.includes(payload.person)))
  //   )
  // },

  async beforeRouteLeave (context, { to, from, next }) {
    if (await actions['pass dirty?'](context)) {
      next()
    } else {
      next(false)
    }
  },

  // Helpers, don't dispatch them
  'valid?': function (context) {
    return context.dispatch('valid', { module: 'meeting' }, { root: true })
  },

  /** If context.state.dirty then open dialog to ask whether to
    1. cancel the action,
    2. commit the form and perform the action
    3. clear the form and perform the action  */
  'pass dirty?': function (context, payload) {
    return context.dispatch('dirty', {
      dirty: context.state.dirty,
      module: 'meeting',
      caller: actions,
      saver: () => {
        actions.save(context, payload || {})
      }
    }, { root: true })
  }
}

export default { namespaced: true, state, getters, mutations, actions }
